import { useWhitelabelConfig } from '@mm/hooks/src/use-whitelabel-config';
import React from 'react';
import { HelpCenter } from '../../../../../../common/components/HelpCenter/HelpCenter';
import { XRayIntegrations } from '../../Integrations/NativeIntegrations/components/XRayIngegrations/XRayIntegrations';
import styles from './XRayLeads.module.css';

export const XRayLeads = () => {
  const helpLink =
    'https://customers.ai/help/l/en/article/16hdqqv4tu-x-ray-installation-guide';

  const { pixelName = 'X-Ray Pixel' } = useWhitelabelConfig();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {pixelName}{' '}
        <HelpCenter helpLink={helpLink} className={styles.helpCenter} />
      </div>
      <XRayIntegrations withTour />
    </div>
  );
};
